import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { type NeedsAttentionItem } from 'xosign-types';
import buildRow from './buildRow.util';
import styles from './NeedsAttention.module.scss';

interface RowProps {
  item: NeedsAttentionItem;
  t: (key: string, opts?: Record<string, unknown>) => string;
}

const Row = ({ item, t }: RowProps) => {
  const copy = buildRow(item, t);
  return (
    <li>
      <Link
        to={`/signings/${item.signing.id}/report/summary`}
        className={styles.row}
      >
        <span
          className={classNames(styles.iconWrap, styles[`tone_${copy.tone}`])}
          aria-hidden="true"
        >
          {copy.icon}
        </span>
        <div className={styles.meta}>
          <div className={styles.title}>{copy.title}</div>
          <div className={styles.subtitle}>{copy.subtitle}</div>
        </div>
      </Link>
    </li>
  );
};

export default Row;
